import axios from '../utils/axios';

const basePath = '/api/resumes';

export const createResume = async (data) => {
	const result = await axios.post('/api/resumes', data);

	return result.data.data;
};

export const updateResume = async (id, data) => {
	const result = await axios.put(`/api/resumes/${id}`, data);

	return result.data.data;
};

export const updateTemplate = async (id, template) => {
	const result = await axios.post(`/api/resumes/${id}/templates`, { template });

	return result.data.data;
};

export const updatePreview = async (id, blob) => {
	const file = new File([blob], `${id}.png`);

	const formData = new FormData();
	formData.append('preview', file);

	try {
		await axios.post(`/api/resumes/${id}/update-preview`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	} catch {
		//ignore error
	}
};

export const retrieveResume = async (id) => {
	const result = await axios.get(`/api/resumes/${id}`);

	return result.data.data;
};

export const viewResume = async (id) => {
	const result = await axios.get(`/api/resumes/preview/${id}`);
  
	return result.data.data;
};

export const retrieveResumes = async () => {
	const result = await axios.get('/api/resumes');
  
	return result?.data?.data || [];
};

export const deleteResumes = async (id) => {
	const result = await axios.delete(`/api/resumes/${id}`);
  
	return result?.data?.data || [];
};

export const downloadResume = async (id) => {
	const result = await axios.get(`/api/resumes/${id}/download`);
  
	return result?.data;
};

const duplicateResume = async (resumeId) => {
	const result = await axios.post(`/api/resumes/${resumeId}/duplicate`);
  
	return result?.data.data;
};

const setPrimaryResume = async (resumeId, status) => {
	const response = await axios.post(`${basePath}/set-primary/${resumeId}`, status);
    
	return response.data;
};

export default {
	resume: {
		duplicate: duplicateResume,
		setPrimary: setPrimaryResume,
	}
};
